import React from 'react';
import { IconButton, InputAdornment, Tooltip } from '@mui/material';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import { generateRandomCode } from '../utils/randomCode';
import TextField from '@mui/material/TextField';
import { withStyles } from 'tss-react/mui';

const styles = {
  tooltip: {
    fontSize: 12
  }
};

class AutoGenInput extends React.PureComponent {
  render() {
    const { classes, autoGenLabel, name, onChange, ...rest } = this.props;
    return (
      <TextField
        id="access-code"
        type="text"
        name={name}
        onChange={onChange}
        {...rest}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title={autoGenLabel} classes={{ tooltip: classes.tooltip }} placement="left">
                  <IconButton
                    aria-label={autoGenLabel}
                    onClick={
                      onChange ? () => onChange({ target: { value: generateRandomCode(8), name: name } }) : undefined
                    }
                    size="large"
                  >
                    <KeyboardIcon />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            )
          }
        }}
      />
    );
  }
}

export default withStyles(AutoGenInput, styles);
